export default __webpack_public_path__ + "static/media/one.7903dbf0.jpeg";